/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getBySurveyid } from '../fn/surveys/get-by-surveyid';
import { GetBySurveyid$Params } from '../fn/surveys/get-by-surveyid';
import { getChats } from '../fn/surveys/get-chats';
import { GetChats$Params } from '../fn/surveys/get-chats';
import { getChatsByResponseid } from '../fn/surveys/get-chats-by-responseid';
import { GetChatsByResponseid$Params } from '../fn/surveys/get-chats-by-responseid';
import { GetSurveyChatResult } from '../models/get-survey-chat-result';
import { GetSurveyChatsResult } from '../models/get-survey-chats-result';
import { GetSurveyResult } from '../models/get-survey-result';
import { postReply } from '../fn/surveys/post-reply';
import { PostReply$Params } from '../fn/surveys/post-reply';

@Injectable({ providedIn: 'root' })
export class ApiSurveysService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSurveysBySurveyid()` */
  static readonly GetSurveysBySurveyidPath = '/Surveys/{SurveyId}';

  /**
   * get-surveys-by-surveyid.
   *
   * Get Survey by id and campaign id<br>Get survey by id and campaign related data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBySurveyid()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBySurveyid$Response(params: GetBySurveyid$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSurveyResult>> {
    return getBySurveyid(this.http, this.rootUrl, params, context);
  }

  /**
   * get-surveys-by-surveyid.
   *
   * Get Survey by id and campaign id<br>Get survey by id and campaign related data
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBySurveyid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBySurveyid(params: GetBySurveyid$Params, context?: HttpContext): Observable<GetSurveyResult> {
    return this.getBySurveyid$Response(params, context).pipe(map((r: StrictHttpResponse<GetSurveyResult>): GetSurveyResult => r.body));
  }

  /** Path part for operation `getSurveysChatsByResponseid()` */
  static readonly GetSurveysChatsByResponseidPath = '/Surveys/chats/{ResponseId}';

  /**
   * get-surveys-chats-by-responseid.
   *
   * Get Survey chat by survey id<br>Get survey chat by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChatsByResponseid()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChatsByResponseid$Response(params: GetChatsByResponseid$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSurveyChatResult>> {
    return getChatsByResponseid(this.http, this.rootUrl, params, context);
  }

  /**
   * get-surveys-chats-by-responseid.
   *
   * Get Survey chat by survey id<br>Get survey chat by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChatsByResponseid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChatsByResponseid(params: GetChatsByResponseid$Params, context?: HttpContext): Observable<GetSurveyChatResult> {
    return this.getChatsByResponseid$Response(params, context).pipe(map((r: StrictHttpResponse<GetSurveyChatResult>): GetSurveyChatResult => r.body));
  }

  /** Path part for operation `getSurveysChats()` */
  static readonly GetSurveysChatsPath = '/Surveys/chats';

  /**
   * get-surveys-chats.
   *
   * Get survey chats by conviveId<br>Get survey chats for a conviveId
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChats$Response(params?: GetChats$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSurveyChatsResult>> {
    return getChats(this.http, this.rootUrl, params, context);
  }

  /**
   * get-surveys-chats.
   *
   * Get survey chats by conviveId<br>Get survey chats for a conviveId
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChats(params?: GetChats$Params, context?: HttpContext): Observable<GetSurveyChatsResult> {
    return this.getChats$Response(params, context).pipe(map((r: StrictHttpResponse<GetSurveyChatsResult>): GetSurveyChatsResult => r.body));
  }

  /** Path part for operation `postSurveysReply()` */
  static readonly PostSurveysReplyPath = '/Surveys/reply';

  /**
   * post-surveys-reply.
   *
   * Reply to Survey
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postReply()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postReply$Response(params?: PostReply$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postReply(this.http, this.rootUrl, params, context);
  }

  /**
   * post-surveys-reply.
   *
   * Reply to Survey
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postReply$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postReply(params?: PostReply$Params, context?: HttpContext): Observable<void> {
    return this.postReply$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
